import { Injectable } from "@angular/core";
import {
  PRIMITIVE,
  ServiceMessageBrokerFactory,
  ServiceMessageBroker,
} from "shared/provider-webworker";

import { TraderGroupLookupService } from "./TraderGroupLookupService";
import { PrimaryLookupService } from "../../impl/PrimaryLookupService";
import { ITraderGroupPromiseLookupService } from "../ITraderGroupPromiseLookupService";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { PromiseLookupService } from "../../impl/PromiseLookupService";

import { CubiqWorker } from "../../../worker/CubiqWorker";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class TraderGroupPrimaryLookupService
  extends PrimaryLookupService<string, CubiqTS.TradingGroupImpl>
  implements ITraderGroupPromiseLookupService
{
  constructor(
    protected base: TraderGroupLookupService,
    protected factory: ServiceMessageBrokerFactory,
    protected cubiqWorker: CubiqWorker,
  ) {
    super(base, factory, CubiqTS.TradingGroupImpl, cubiqWorker, "TradingGroupImpl");

    cubiqWorker.isAuth(`${this.constructor.name}`).then(
      () => {
        let traderGroupsObservable = cubiqWorker.primeStaticData<CubiqTS.TradingGroupImpl>(
          CubiqTS.TradingGroupImpl.name,
        );

        traderGroupsObservable.subscribe(
          (traderGroups: CubiqTS.TradingGroupImpl[]) => {
            this.base.prime(traderGroups);
          },
          (error: Error) => {
            console.debug("CurrencyPair prime failed");
            this._primed.reject(error);
          },
          () => {
            this._primed.resolve(true);
          },
        );
      },
      (reason) => {
        console.debug("TraderGroupPrimaryLookupService: Failed to prime: " + reason);

        this._primed.resolve(false);
      },
    );

    this.broker.registerMethod(
      "getTraderGroup",
      [PRIMITIVE],
      this.getTraderGroup.bind(this),
      this.VALUE,
    );
    this.broker.registerMethod(
      "getTraderGroupForSid",
      [PRIMITIVE],
      this.getTraderGroup.bind(this),
      this.VALUE,
    );
  }

  // Does not work since Long encoded as primitive, use getTraderGroupForSid()
  getTraderGroup(id: CubiqTS.Long): Promise<CubiqTS.TradingGroupImpl> {
    return new Promise<CubiqTS.TradingGroupImpl>((res, rej) => {
      res(this.base.getTraderGroup(id));
    });
  }

  getTraderGroupForSid(sid: string): Promise<CubiqTS.TradingGroupImpl> {
    return new Promise<CubiqTS.TradingGroupImpl>((res, rej) => {
      res(this.base.getTraderGroupForSid(sid));
    });
  }
}
